import { Either } from "src/base/Either";
import { Failure } from "src/base/Failure";
import { ImageHistory } from "../../data/models/medicalRecord";
import { IMedicalRecordRepository } from "../../data/repositories/medicalRecordRepository";

export class FetchImageHistoryRecord {
  repository: IMedicalRecordRepository;

  constructor(repository: IMedicalRecordRepository) {
    this.repository = repository;
  }

  async execute(imageId: string): Promise<Either<Failure, ImageHistory[]>> {
    return await this.repository.fetchImageHistoryRecord(imageId);
  }
}